import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeNlBeExtra from '@angular/common/locales/extra/nl-BE';
import localeNlBE from '@angular/common/locales/nl-BE';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
registerLocaleData(localeNlBE, 'nl-BE', localeNlBeExtra);

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleChartsModule } from 'angular-google-charts';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { DefaultComponent } from './default/default.component';
import { TwoFactorAuthenticationService } from './modules/authentication/2fa/services/2fa.service';
import { ConfirmState } from './shared/dialogs/models/ConfirmState';
import { DialogService } from './shared/dialogs/services/DialogService';
import { SharedModule } from './shared/shared.module';
import { EmployeeService } from './shared/personnel-files/services/employee.service';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    GoogleChartsModule.forRoot(),
    InfiniteScrollModule,
    MatDialogModule,
    DragDropModule,
    CoreModule.forRoot(),
    SharedModule,
    AppRoutingModule,
  ],
  declarations: [
    AppComponent,
    DefaultComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    DialogService,
    //EmployeeService Singleton to ensure only one instance is used across the app
    EmployeeService,
    ConfirmState,
    {
      provide: LOCALE_ID,
      useValue: 'nl-BE',
    },
    TwoFactorAuthenticationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
